import { Manager } from "@lib/types/Manager";
import { FaHistory } from "react-icons/fa";
import { FormattedMessage } from "react-intl";
// import TelegramTab from "./Telegram";
import LoginHistory from "./LoginHistory";
import { AppTabProps } from "@lib/components/AppComponents/AppTabs";

export type TabProps = {
  manager?: Manager;
  selectedTab: boolean;
};

export const getManagerDetailTabs = (): AppTabProps<TabProps>[] => [
  // {
  //   key: "telegram",
  //   Title: <FormattedMessage id={"common.telegram"} />,
  //   Icon: <FaTelegram />,
  //   Component: TelegramTab,
  // },
  {
    key: "login-history",
    Title: <FormattedMessage id="userProfile.loginHistory" />,
    Icon: <FaHistory />,
    Component: LoginHistory,
  },
];
